var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{ref:"modal",attrs:{"id":"export-dialog","title":_vm.$t('bookings.export'),"size":"sm","centered":""}},[_c('form',{ref:"form",on:{"submit":_vm.submit}},[_c('fields')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }